import * as t from 'src/locales/ja'
export type StateObj = {
  value: string
  label: string
  color?: string
  key?: string
  price?: number
  order?: number
}

export type Embroidery = {
  id: number
  typeFace: StateObj
  position: StateObj
  color: StateObj
  shadowColor: StateObj
  edgeColor: StateObj
  pointColor?: StateObj
  content: string
}

export type State = {
  baseModel: Model
  isStaffOnly?: boolean
  series?: StateObj
  tanner?: StateObj
  kinds?: StateObj
  dominantArm: StateObj
  size?: StateObj
  fingerGuardType: StateObj
  fingerGuardPosition?: StateObj
  mouton?: StateObj
  webParts?: StateObj // パーツ
  printLeatherType?: StateObj
  parts: StateObj
  all: StateObj
  catchFace: StateObj
  edge: StateObj
  lace: StateObj
  linings: StateObj
  hamidashi: StateObj
  listLiningsMaterial?: StateObj
  stitch: StateObj
  web: StateObj
  web2?: StateObj
  thumbHook: StateObj
  littleHook: StateObj
  listBelt: StateObj
  indexCover: StateObj
  isLoading: boolean
  // 内野手用グラブここから
  thumbOut?: StateObj
  thumbWeb?: StateObj
  thumbRoot?: StateObj
  thumbWebAndIndexWeb?: StateObj
  thumbIndexMiddle?: StateObj
  thumbIndexMiddleRight?: StateObj // キャッチャーミットで使用
  indexWeb?: StateObj
  indexMiddle?: StateObj
  indexMiddleRight?: StateObj // DxMのみ
  middleIndex?: StateObj
  middleRing?: StateObj
  indexLeftMiddleRight?: StateObj
  middleLeftRing?: StateObj
  middleLeftRingRight?: StateObj
  middleLeftRingLittle?: StateObj // キャッチャーミットで使用
  ringLeftLittleRight?: StateObj
  ringMiddle?: StateObj
  ringLittle?: StateObj
  littleRing?: StateObj
  littleOut?: StateObj
  little?: StateObj
  // TODO: HUDは廃止になったはずなので削除を検討
  hudLeft?: StateObj
  hudRight?: StateObj
  bknLeft?: StateObj
  bknRight?: StateObj
  loopOfRingFingerColor?: StateObj
  hamidashiCut?: StateObj // DxMのみ
  // 投手用グラブここから
  backStyle?: StateObj
  materialPack?: StateObj
  // 一塁手用ミットここから
  thumb?: StateObj
  underWeb?: StateObj
  boomerang?: StateObj
  // 捕手用ミットここから
  thumbMachi?: StateObj
  littleMachi?: StateObj
  catchFaceTarget?: StateObj
  indexAndMiddle?: StateObj
  fingerStand?: StateObj
  indexFingerTipOut?: StateObj
  // 各ブランドのラベル
  atomsLabel?: StateObj
  ysrLabel?: StateObj
  specifyLabel?: StateObj // only DxM
  dxmLabel?: StateObj
  dxmLabelCore?: StateObj
  gorillaLabel?: StateObj
  // atomsにあるもの
  backLace?: StateObj
  // yellstory固有のもの
  leatherIntegratedIndex?: StateObj
  leatherIntegratedMiddle?: StateObj
  leatherIntegratedRing?: StateObj
  ysrOriginalEmbroidery?: StateObj
  ysrDirectLogo1Position?: StateObj
  ysrDirectLogo1MainColor?: StateObj
  ysrDirectLogo1EdgeColor?: StateObj
  ysrDirectLogo2Position?: StateObj
  ysrDirectLogo2Color?: StateObj
  bankLaceDirection?: StateObj
  // ragdelion, treasureにあるもの
  beltType?: StateObj

  loopOfRingFinger?: StateObj
  loopOfRingFingerSize?: StateObj

  // 刺繍
  embroideries: Embroidery[]
  moldingOrder?: StateObj
  // 個人情報
  personal: Personal
  figurePanelNum: number //0 | 1
  images: {
    // canvasをimageに変換したURL
    front: string
    rear: string
  }
}

export type ShoesState = {
  baseModel: ShoesModel
  upperMaterial: StateObj
  size: StateObj
  openingPattern: StateObj // 履き口
  vampStrapType: StateObj // 甲止めストラップ
  tongue: StateObj // 靴ベロ
  outSole: StateObj // アウトソール
  lineType: StateObj // ライン
  toeGuard: StateObj // P革
  toeGuardKind: StateObj // P革の種類

  // color
  line: StateObj
  line2: StateObj
  vampStrap: StateObj
  vampStrapBelt1: StateObj
  vampStrapBelt2: StateObj
  vampStrapBelt3: StateObj
  stitch: StateObj
  tongueLinings: StateObj
  middleCutOpening: StateObj
  atomsLabel: StateObj
  parts: StateObj
  magicBeltMaterial: StateObj
  magicBeltBase: StateObj
  toeGuardColor: StateObj

  // parts
  whole: StateObj
  mainUnit: StateObj
  toeReinforcement: StateObj
  vampStrapReinforcement: StateObj
  healReinforcement: StateObj
  sideReinforcement: StateObj
  openingReinforcement: StateObj
  opening: StateObj
  healDecoration: StateObj
  tongueFront: StateObj

  embroideries: Embroidery[]
  personal: Personal
  figurePanelNum: 0 | 1 | 2 | 3 // ゆくゆくはoptionalを消したい
  images: {
    // canvasをimageに変換したURL
    front: string
    side: string
    rear: string
  }
}

export type DevTools = {
  coordinateX: number
  coordinateY: number
  isCopy: boolean
  setCopy: (value: React.SetStateAction<boolean>) => void
}

export type PartialAction = { type: string; router?: string } & Partial<State>
export type PartialShoesAction = { type: string } & Partial<ShoesState>

export type PartialActionDispatch = (value: PartialAction) => void
export type PartialShoesActionDispatch = (value: PartialShoesAction) => void
export type Action = { type: string; router?: string } & State
export type ShoesAction = { type: string; router?: string } & ShoesState

export type Personal = {
  userName: string
  userNameKana: string
  phoneNumber: string
  mailAddress: string
  league: string
  remarks: string
  address?: string // 2025/09/04時点、シューズのみ使用
  position?: string | string[]
}

export type EmbroideryObjects = {
  typeFace: StateObj[]
  position: StateObj[]
  color: StateObj[]
  shadowColor: StateObj[]
  edgeColor: StateObj[]
  pointColor?: StateObj[]
}

export type Position = 'pitcher' | 'infielder' | 'outfielder' | 'first' | 'catcher' | ''
export type Brand = 'atoms' | 'yellStory' | 'dxm' | 'gorilla'

export type EmbroideryKey = 'typeFace' | 'position' | 'color' | 'shadowColor' | 'edgeColor' | 'pointColor' | 'content'

export type Model = {
  productNumber: string
  subProductNumber?: string
  position?: Position | ''
  imageUrl: string
  dominantArm: 'both' | 'right' | 'left' | 'unselected' | '미선택'
  size: number
  webParts: string
  description: string
  series: string
  isFingerCrotch?: boolean
  isUBack?: boolean
  ugLeatherPrice?: number
  bomberPrice?: number
  backStyle?: string
  brand?: Brand
  softPrice?: number
  price?: number
  imageWidth: number
  imageHeight: number
}

export type ShoesModel = {
  productNumber: string
  brand: 'atoms'
  size: number
  description: string
  image: {
    url: string
    width: number
    height: number
  }
}

export type Agency = {
  name: string
  email: string
  brands?: Brand[]
}

export type DocumentContent = {
  text: string
  fontSize: number
  alignment?: undefined | string
}
export type DocumentContentGenerator = (head: string, content: string, alignment?: string, color?: string) => DocumentContent[]

export type ResponseDispatch = (selected: string) => void
export type WebPartsObj = {
  label: string
  value: string
  position: Position[]
  imageUrl: string
  isYouth?: boolean
}

export type BaseInitialState = {
  isLoading: boolean
  backStyle: StateObj
  dominantArm: {
    label: string
    value: string
  }
  size: {
    label: string
    value: string
  }
  fingerGuardType: {
    label: string
    value: string
  }
  baseModel: Model
}

export type I18NText = typeof t.default

export type Response = {
  savedId: string
  state: State | ShoesState | import('src/features/atoms/bat/types').BatState
  createdAt: {
    nanoseconds: number
    secondes: number
  }
  paymentCompletedAt?: {
    nanoseconds: number
    secondes: number
  }
  paymentIntentId?: string
}

/**
 * API レスポンスの基本型
 */
export type ApiResponse<T> = {
  response: T
}

/**
 * ドキュメント取得APIのレスポンス型
 */
export type DocumentApiResponse = ApiResponse<{
  state: State | ShoesState | import('src/features/atoms/bat/types').BatState
  createdAt: {
    nanoseconds: number
    secondes: number
  }
  // 決済・注文関連のフィールド（Stripe webhookとstatusで追加される）
  paymentIntentId?: string
  orderRequestedAt?: string
  orderAcceptedAt?: string
  paymentCompletedAt?: {
    nanoseconds: number
    secondes: number
  }
  // 購入者情報（Stripe webhookで追加される）
  purchaser?: PurchaserInfo
}>

/**
 * API クライアントのエラー型
 */
export class ApiClientError extends Error {
  constructor(
    message: string,
    public originalError?: unknown
  ) {
    super(message)
    this.name = 'ApiClientError'
  }
}

/**
 * PDF署名生成APIのレスポンス型
 */
export type SignatureResponse = {
  signature: string
  timestamp: string
  clientId: string
  serviceUrl: string
  createdAt: {
    secondes: number
    nanoseconds: number
  }
}

/**
 * PDF生成リクエストのパラメータ型
 */
export type PDFGenerationRequest = {
  requestData: unknown
  idToken: string
}

/**
 * PDF生成APIのレスポンス型
 */
export type PDFGenerationResponse = Blob

// シミュレーション保存API関連の型定義
export type SaveSimulationRequest = {
  state: State & {
    images?: {
      front: string
      rear: string
    }
  }
}

export type SaveSimulationResponse = {
  id: string
}

// メール送信API関連の型定義（レガシー、新規開発ではUnifiedSendMailRequestを使用）
export type SendMailRequest = {
  subject: string
  savedId: string
  imageUrls: {
    front: string
    rear: string
  }
  email: string
  locale: string
}

export type SendMailResponse = {
  success: boolean
}

// 統合されたメール送信API型定義
export type UnifiedSendMailRequest = {
  subject: string
  savedId: string
  imageUrls: {
    front: string
    rear: string
    side?: string // シューズの場合のみ必要
  }
  email: string
  locale: string
}

// シューズ専用のシミュレーション保存API関連の型定義
export type SaveShoesSimulationRequest = {
  state: ShoesState & {
    images?: {
      front: string
      side: string
      rear: string
    }
  }
}

export type SaveShoesSimulationResponse = {
  id: string
}

// シューズ専用のメール送信API関連の型定義（レガシー、新規開発ではUnifiedSendMailRequestを使用）
export type SendShoesMailRequest = {
  subject: string
  savedId: string
  imageUrls: {
    front: string
    side: string
    rear: string
  }
  email: string
  locale: string
}

// バット専用のシミュレーション保存API関連の型定義
export type SaveBatSimulationRequest = {
  state: import('src/features/atoms/bat/types').BatState & {
    images?: {
      front: string
    }
  }
}

export type SaveBatSimulationResponse = {
  id: string
}

// バット専用のメール送信API関連の型定義
export type SendBatMailRequest = {
  subject: string
  savedId: string
  imageUrls: {
    front: string
  }
  email: string
  locale: string
}

export type Locale = {
  locale: string
  t: I18NText
  isEn: boolean
  isKo: boolean
  isJa: boolean
  isForeign: boolean
  language: Language
}

/**
 * API クライアント用のヘルパー型
 */
export type DocumentWithState<T extends State | ShoesState | import('src/features/atoms/bat/types').BatState> = {
  state: T
  createdAt: Response['createdAt']
  // 決済・注文関連のフィールド（Stripe webhookとstatusで追加される）
  paymentIntentId?: string
  orderRequestedAt?: string
  orderAcceptedAt?: string
  paymentCompletedAt?: {
    nanoseconds: number
    secondes: number
  }
  // 購入者情報（Stripe webhookで追加される）
  purchaser?: PurchaserInfo
}

export type DocumentWithMetadata<T extends State | ShoesState | import('src/features/atoms/bat/types').BatState> = DocumentWithState<T> & {
  savedId: string
}

// 支払い関連の型定義
export type PaymentStatus = 'PAYMENT_COMPLETED' | 'ORDER_REQUESTED' | 'ORDER_COMPLETED' | 'INSPECTION_COMPLETED' | 'SHIPPED'

export type PaymentItem = {
  paymentId: string
  date: string
  simulationId: string
  amount: number
  status: PaymentStatus
  createdAt: string
}

export type PaymentListResponse = {
  payments: PaymentItem[]
  total: number
}

export type PaymentItemMetadata = {
  orderStatus: string
}

export type PaymentItemDetail = {
  metadata: PaymentItemMetadata
  shipping: {
    // 配送先情報
    address: {
      city: string
      country: string
      line1: string
      line2: string | null
      postal_code: string
      state: string // 都道府県
    }
    name: string
    phone: string | null
  }
  receipt_email: string // 注文者のメールアドレス
}

/**
 * 購入者情報の型定義
 */
export type PurchaserInfo = {
  name: string | null
  email: string | null
  phone: string | null
  address: {
    line1: string
    line2: string | null
    city: string
    state: string
    postal_code: string
    country: string
  } | null
}

/**
 * Firestoreのシューズシミュレーションドキュメントの型定義
 */
export type ShoesSimulationDocument = {
  // 既存フィールド（必要に応じて追加）
  paymentIntentId?: string
  paymentCompletedAt?: any // Firestore Timestamp
  orderRequestedAt?: string
  // 新規フィールド
  purchaser?: PurchaserInfo
}

/**
 * チェックアウトセッション作成のリクエストデータ
 */
export type CreateCheckoutSessionRequest = {
  amount: number
  simulationId: string
}

/**
 * チェックアウトセッション作成のレスポンスデータ
 */
export type CreateCheckoutSessionResponse = {
  id: string
  createdAt: string
}

/**
 * カスタムクレームの型定義
 */
export type CustomClaims = {
  isPaymentAdmin?: boolean
}

/**
 * カスタムクレーム設定のリクエストデータ
 */
export type SetCustomClaimsRequest = {
  email: string
  customClaims: CustomClaims
}

/**
 * カスタムクレーム設定のレスポンスデータ
 */
export type SetCustomClaimsResponse = {
  message: string
}

/**
 * 小売店情報
 */
export type RetailInfo = {
  name: string
  email: string
  selectableBrands: StateObj[]
  createdAt: {
    nanoseconds: number
    secondes: number
  }
}

/**
 * 小売店情報（統合版）のレスポンスデータ
 */
export type FetchRetailResponse = {
  retail: {
    name: string
    email: string
    selectableBrands: StateObj[]
  }
}

/**
 * 支払いステータス更新のリクエストデータ
 */
export type UpdatePaymentStatusRequest = {
  paymentId: string
  newStatus: string
  orderRequestedAt?: string | null
  orderAcceptedAt?: string | null
  simulationId?: string
  trackingNumber?: string
  createdAt: {
    nanoseconds: number
    secondes: number
  }
}

/**
 * 支払いステータス更新のレスポンスデータ
 */
export type UpdatePaymentStatusResponse = {
  success: boolean
  createdAt: {
    nanoseconds: number
    secondes: number
  }
}

// 発送完了メール送信API関連の型定義
export type SendShoesShippingMailRequest = {
  paymentData: any // TODO: 適切な型を定義する
  trackingNumber: string
  shippingCompany: string
}

export type SendShoesShippingMailResponse = {
  message: string
}

// 小売店発注メール送信API関連の型定義
export type OrdererInfo = {
  name: string
  kana: string
  mailAddress: string
  phoneNumber: string
  league: string
  position?: string
  remarks: string
}

export type SettingsItem = {
  head: string
  label: string
}

export type SendRetailOrderMailRequest = {
  subject: string
  agencyEmail: string
  retailEmail: string
  retailName: string
  savedId: string
  imageUrls: {
    front: string
    rear: string
    side: string | null // シューズの場合のみ必要
  }
  baseSettings: SettingsItem[]
  colorSettings1: SettingsItem[]
  colorSettings2: SettingsItem[] | null // シューズの場合は不要
  embroideries: SettingsItem[][]
  orderer: OrdererInfo
  locale: string
  pdfBase64: string
  pdfBase64Tw?: string
}

export type SendShoesOrderMailRequest = {
  subject: string
  agencyEmail: string
  retail: {
    email: string
    name: string
  }
  savedId: string
  simulationId: string
  orderRequestedAt: string
  images: {
    front: string
    side: string
    rear: string
  }
  baseSettings: SettingsItem[]
  colorSettings1: SettingsItem[]
  embroideries: SettingsItem[][]
  orderer: OrdererInfo
  locale: string
}

export type SendOrderMailResponse = {
  success: boolean
}

// 支払い管理からのシューズ発注メール送信API関連の型定義
export type SendShoesOrderFromPaymentRequest = {
  simulationId: string
  images: {
    front?: string
    side?: string
    rear?: string
  }
  baseSettings: SettingsItem[]
  colorSettings1: SettingsItem[]
  embroideries: SettingsItem[][]
  orderer: {
    name: string
    kana: string
    mailAddress: string
    phoneNumber: string
    league: string
    remarks: string
  }
  orderRequestedAt: string
}

// ATOMS本社宛決済完了通知メール送信API関連の型定義
export type SendShoesPaymentNotificationRequest = {
  simulationId: string
  createdAt: string
}

export type SendShoesPaymentNotificationResponse = {
  success: boolean
}

// 分析データ取得API関連の型定義
export type FetchAnalysisDataRequest = {
  league: string
  position: string
  brand: string
}

export type FetchAnalysisDataResponse = {
  response: State[]
}

// パスワードリセット関連の型定義
export type PasswordResetResponse = {
  success: boolean
  message: string
}

// サインイン関連の型定義
export type SignInRequest = {
  email: string
  password: string
}

export type SignInResponse = {
  success: boolean
  message: string
  user?: {
    uid: string
    email: string | null
  }
  createdAt: {
    nanoseconds: number
    secondes: number
  }
}

export type Product = 'glove' | 'shoes' | 'bat'

export type Language = 'en' | 'ja' | 'ko' | 'zh-TW'
